import Vue from 'vue'
import VueRouter from 'vue-router'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

//userType 能访问的用户类型 9超级管理员 1管理员 0教师
//大于当前类型的用户也可访问
Vue.use(VueRouter)

const routes = [
  {
    path: '/web/file',
    name: '预览',
    component: () => import('../views/file-view.vue'),
  },
  {
    path: '/op/embedcommon.aspx',
    name: '预览',
    component: () => import('../views/file-view.vue'),
  },
  {
    path: '/op/embed.aspx',
    name: '预览',
    component: () => import('../views/file-view.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: '',
  //base: '/frontend-tea/',//博飞教学平台使用
  routes: routes,
})

// 配置路由权限
router.beforeEach((to, from, next) => {
  // if (window._hmt) {
  //   if (to.path) {
  //     window._hmt.push(['_trackPageview', '/#' + to.fullPath])
  //   }
  // }
  // let cookieUType = getCookie('RecordUserType');
  // if (cookieUType) {
  //   let uType = to.meta.userType
  //   if (uType != undefined) {
  //     //页面所需权限大于当前权限时，跳转
  //     //type 1 管理员跳转到首页
  //     //type 0 老师跳转到资源页面
  //     if (uType > parseInt(cookieUType)) {
  //       let nextPath = '/resource/home'
  //       if (uType == 0) {
  //         nextPath = '/resource/resource'
  //       }
  //       next({
  //         path: nextPath
  //       })
  //     }
  //   }
  // }
  next()
})

export function getCookie(name) {
  var strcookie = document.cookie //获取cookie字符串
  var arrcookie = strcookie.split('; ') //分割
  //遍历匹配
  for (var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split('=')
    if (arr[0] == name) {
      return arr[1]
    }
  }
  return ''
}

export default router
